/* {a: 143, c: 454, b: 1} --> {a: 143, b: 1, c: 454} */
export const sortObjectKeys = (unordered: object) => {
    return Object.keys(unordered)
        .sort()
        .reduce((obj, key) => {
            obj[key] = unordered[key];
            return obj;
        }, {});
};
